import asyncLoadImage from './utils/async-load-image';
import isBannerOpen from './utils/is-banner-open';
import closeButtonEvent from './utils/close-button-event';
import { setOverlaySessionStorage, getOverlaySessionStorage } from './utils/set-overlay-session-storage';

import {
	centralOverlayElement,
	openText,
	closedText,
	hiddenClass,
	visibleClass,
} from './constants';

const isCentralOverlayOpen = isBannerOpen( centralOverlayElement );

const centralOverlayDesktopWidth = {
	dpi1x: '?width=800',
	dpi2x: '?width=1600',
};

const centralOverlayMobileWidth = {
	dpi1x: '?width=300',
	dpi2x: '?width=600',
};

export default function campaignCentralOverlay ( campaignData ) {
	if ( centralOverlayElement && campaignData ) {
		if ( campaignData.gaLabel ) {
			centralOverlayElement.setAttribute(
				'data-component-name',
				campaignData.gaLabel,
			);
		}

		// Desktop image
		const centralOverlayDesktopImage = centralOverlayElement.querySelector(
			'[data-js-piano-central-overlay-desktop-image]',
		);

		// Mobile image
		const centralOverlayMobileImage = centralOverlayElement.querySelector(
			'[data-js-piano-central-overlay-mobile-image]',
		);

		let isModalVisible = false;

		const delay = campaignData.delay
			? parseInt( campaignData.delay, 10 ) * 1000
			: 0;

		let overlayTimeoutId;

		const overlayTimeout = () => {
			if ( isCentralOverlayOpen ) {
				overlayTimeoutId = setTimeout( () => {
					// Update the exit overlay desktop & mobile image
					if ( campaignData.adDescription ) {
						centralOverlayDesktopImage.setAttribute( 'alt', campaignData.adDescription );
						centralOverlayMobileImage.setAttribute( 'alt', campaignData.adDescription );
					}

					asyncLoadImage(
						campaignData.desktopImageSrc,
						centralOverlayDesktopImage,
						centralOverlayDesktopWidth,
					);


					asyncLoadImage(
						campaignData.mobileImageSrc,
						centralOverlayMobileImage,
						centralOverlayMobileWidth,
					);

					// Open and show the exit overlay
					centralOverlayElement.showModal();
					centralOverlayElement.classList.add( visibleClass );
					setOverlaySessionStorage( centralOverlayElement, openText );
					isModalVisible = true;
				}, delay );
			} else {
				setOverlaySessionStorage( centralOverlayElement, closedText );
			}
		};

		// Modal "onLoad"
		if ( campaignData.loadType === 'onLoad' ) {
			overlayTimeout();
		} else if ( campaignData.loadType === 'afterOpenNewTab' ) {
			// Modal "afterOpenNewTab"
			document.addEventListener( 'visibilitychange', () => {
				if ( document.visibilityState === 'hidden' ) {
					! isModalVisible && overlayTimeout();
				} else {
					clearTimeout( overlayTimeoutId );
				}
			} );
		}

		const centralOverlayLink = centralOverlayElement.querySelector( '[data-js-piano-central-overlay-link]' );

		if ( campaignData.campaignLink ) {
			centralOverlayLink.setAttribute( 'href', ampaignData.campaignLink );
		}

		closeButtonEvent( centralOverlayElement, true );
	} else {
		if ( ! centralOverlayElement ) {
			return;
		}

		centralOverlayElement.classList.remove( visibleClass );
		centralOverlayElement.classList.add( hiddenClass );
		centralOverlayElement.close();
	}
}
